var _circle, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnifiedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 9.5,
    r: 9.5,
    fill: "#FFFDE7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3821_19536",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 6,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H18V22H2V6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3821_19536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.28125 20.125C5.28125 19.3483 4.65166 18.7187 3.875 18.7187C3.09834 18.7187 2.46875 19.3483 2.46875 20.125C2.46875 20.9017 3.09834 21.5312 3.875 21.5312C4.65166 21.5312 5.28125 20.9017 5.28125 20.125Z",
    stroke: "#F9A825",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4063 20.125C11.4063 19.3483 10.7767 18.7187 10 18.7187C9.22334 18.7187 8.59375 19.3483 8.59375 20.125C8.59375 20.9017 9.22334 21.5312 10 21.5312C10.7767 21.5312 11.4063 20.9017 11.4063 20.125Z",
    stroke: "#F9A825",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5313 20.125C17.5313 19.3483 16.9017 18.7187 16.125 18.7187C15.3483 18.7187 14.7188 19.3483 14.7188 20.125C14.7188 20.9017 15.3483 21.5312 16.125 21.5312C16.9017 21.5312 17.5313 20.9017 17.5313 20.125Z",
    stroke: "#F9A825",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.875 8.53125L10 6.65625L8.125 8.53125",
    stroke: "#F9A825",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18.7188V6.65625",
    stroke: "#F9A825",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 18.7188V18.25C16.125 14.9687 10 14.9687 10 11.6875M10 11.6875C10 8.0625 10 8.0625 10 11.6875ZM10 11.6875C10 14.9687 3.875 14.9687 3.875 18.25V18.7188",
    stroke: "#F9A825",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnifiedIcon);
export default __webpack_public_path__ + "static/media/unified_icon.9bee16e0b567165d591964f56585fd39.svg";
export { ForwardRef as ReactComponent };